<template lang="pug">
.wrapper
    .main-container
        //- Header Global
        HeaderGlobal(HeaderGlobalHeading="Dashboard").py-4
        .flex.flex-wrap(class="sm:m-0 lg:-mx-4")
            .block(class="w-full lg:w-5/12 lg:px-4")
                .box.w-full
                    header.box__header.no-border.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Latest Search
                    .box__body.p-4
                        .flex.flex-wrap.items-center.justify-center(v-if="load_data_status_clients_log_activity === 'loading'")
                            Spinner(show="true" size="48")

                        template(v-else-if="clients_log_activity.data && clients_log_activity.data.length > 0")
                            .latest.flex.items-center.border-b.justify-between.pb-4.mb-4(v-for="(search,index) in clients_log_activity.data" :key="index")
                                .flex.flex-grow.items-start(class="flex-col lg:flex-row lg:items-center")
                                    router-link.link-text.monospace(
                                        style="min-width:200px"
                                        :to="'/result/'+ encrypt(search.key +'&&'+ search.type) +'/recent-location'"
                                        ) {{ search.key }}
                                    span.block.mr-6.text-xs.uppercase {{ search.type }}
                                span.block.mr-6.text-xs.time
                                    //- | {{ search.created_at.substr(0, 16) }} WIB
                                    | {{ datetimeFormat(search.created_at) }}
                                    //- | {{ search.created_at }}

                                //- router-link.btn-primary-o.btn-small(:to="'/result/'+ encrypt(search.key +'&&'+ search.type) +'/recent-location'") Search

                        .text-center(v-else) No Data Available

            .block(class="w-full lg:w-7/12 lg:px-4")
                .box.w-full
                    header.box__header.no-border.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Latest Added As Targets
                        .header-cta
                            router-link.btn-primary.btn-small(to="/target") View All Target
                    .box__body.p-4
                        .flex.flex-wrap.items-center.justify-center(v-if="load_data_status_single_target_list.status === 'loading'")
                            Spinner(show="true" size="48")

                        template(v-else-if="addedTarget.length > 0")
                            .latest(v-for="(added,index) in addedTarget" :key="index").flex.items-center.border-b.justify-between.pb-4.mb-4
                                .flex.flex-grow.items-start(class="flex-col lg:flex-row lg:items-center")
                                    router-link.link-text(
                                        style="min-width:200px"
                                        :to="added.type === 'msisdn' ? '/target/'+ added.id +'/detail/'+ encrypt(added.value +'&&msisdn') +'/home' : '/target/'+ added.id +'/detail/home'"
                                        ).monospace.font-bold {{ added.value }}
                                    span.block.mr-6.text-xs As {{ added.target_name }}
                                span.block.mr-6.text-xs.time {{ added.created_at }}

                        .text-center(v-else) No Data Available
</template>

<script>
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import { mapState } from 'vuex';
import Spinner from '@/components/Spinner.vue';
import { encrypt } from '@/util/crypto';
import moment from 'moment';

export default {
    name: 'Dashboard',
    components: {
        HeaderGlobal,
        Spinner,
    },
    // metaInfo: {
    //   title: 'Dashboard',
    //   titleTemplate: '%s | ' + process.env.VUE_APP_APP_NAME,
    // },
    metaInfo() {
        return {
            title: 'Dashboard',
            titleTemplate: '%s | ' + this.$store.getters.getTitleGlobal,
        };
    },
    data: function() {
        return {
            latestSearch: [
                {
                    num: '098576485762',
                    date: '10 minutes ago',
                    type: 'IMEI',
                    url: '/id',
                },
                {
                    num: '0875647382736',
                    date: '2 hours ago',
                    type: 'IMEI',
                    url: '/id',
                },
                {
                    num: '08527384756387',
                    date: 'Yesterday',
                    type: 'IMEI',
                    url: '/id',
                },
                {
                    num: 'AB1234ZYZ',
                    date: 'Yesterday',
                    type: 'STNK',
                    url: '/id',
                },
                {
                    num: '17485748574837',
                    date: 'Yesterday',
                    type: 'IMEI',
                    url: '/id',
                },
                {
                    num: 'AB1234ZYZ',
                    date: '04/11/2020',
                    type: 'STNK',
                    url: '/id',
                },
                {
                    num: '17485748574837',
                    date: '04/11/2020',
                    type: 'IMEI',
                    url: '/id',
                },
                {
                    num: 'AB1234ZYZ',
                    date: '04/11/2020',
                    type: 'STNK',
                    url: '/id',
                },
                {
                    num: '17485748574837',
                    date: '04/11/2020',
                    type: 'IMEI',
                    url: '/id',
                },
                {
                    num: 'AB1234ZYZ',
                    date: '04/11/2020',
                    type: 'STNK',
                    url: '/id',
                }
            ],
            addedTarget: [],
        }
    },
    computed: {
        ...mapState([
            'load_data_status_clients_log_activity',
            'load_data_status_single_target_list',
            'single_target_list',
            'clients_log_activity',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name(newData) {
            if (newData === 'PageDashboard') {
                this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
                this.getData();
            }
        },
        single_target_list(newData) {
            if (Object.keys(newData).length > 0 && newData.data && newData.data.length > 0) {
                let target_list = [];

                for (var i = 0; i < newData.data.length; i++) {
                    for (var j = 0; j < newData.data[i].clues.length; j++) {

                        if (target_list.length >= 10)
                            break;

                        target_list.push({
                            id: newData.data[i].id,
                            target_name: newData.data[i].target_name,
                            type: newData.data[i].clues[j].name,
                            value: newData.data[i].clues[j].value,
                            created_at: newData.data[i].created_at,
                        });
                    }
                }

                this.addedTarget = target_list;
            }
        },
    },
    methods: {
        getData() {
            // for dispatch get data
            if (this.route_name === 'PageDashboard') {
                this.$store.dispatch('getClientsLogActivity', [10, 1]);
                this.$store.dispatch('getSingleTargetList', [10, 1, null, null, null, null, 'dashboard']);
            }
        },
        encrypt(string) {
            return encrypt(string);
        },
        datetimeFormat(datetime) {
            let dtm = moment(datetime, 'YYYY-MM-DD hh:mm:ssZ').format('DD MMMM YYYY HH:mm:ss');
            if (dtm != 'Invalid date') {
                dtm = dtm + ' WIB'
            } else {
                dtm = datetime
            }
            return dtm;
            // console.log(moment(datetime, 'YYYY-MM-DD hh:mm:ss+0700').zone('+0700').format('DD MMM YYYY HH:mm:ss'));
            // return moment(datetime, 'YYYY-MM-DD hh:mm:ss+0700').format('DD MMM YYYY HH:mm:ssZ');

            // return moment(datetime, 'YYYY-MM-DD hh:mm:ss+0700').utcOffset('+0700').format('DD MMMM YYYY HH:mm:ss') + ' WIB';
            // return moment(datetime, 'YYYY-MM-DD hh:mm:ssZ').format('DD MMMM YYYY HH:mm:ss') + ' WIB';
        },
    },
    mounted: function() {
        // this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
        this.getData();
    },
    // destroyed() {
    //     this.$store.commit('setLoadDataStatusSingleTargetList', { cancel: null, status: false });
    // },
}
</script>

